import { axios } from '#api/axios';
import { useNavigate } from 'react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToast } from '#providers/ToastProvider';

type QnaCommunityAnswerProps = {
  questionId?: string;
  writerId?: string;
  content: string;
  sequence?: number;
  receiverId?: string;
};

const useAnswerMutations = ({
  questionId,
  isEdit
}: {
  questionId?: string;
  isEdit: boolean;
}) => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutate: answerMutate } = useMutation({
    mutationFn: async (payload: QnaCommunityAnswerProps) => {
      isEdit
        ? await axios.patch(`/consumer/qna/answers`, { ...payload })
        : await axios.post(`/consumer/qna/${payload.questionId}/answers`, {
            ...payload
          });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get-qna-community-question-answer', questionId]
      });
      queryClient.invalidateQueries({
        queryKey: ['get-qna-community-thread-comment-count', questionId]
      });
      queryClient.invalidateQueries({
        queryKey: ['get-qna-community-question', questionId]
      });
      showToast({
        message: `글을 ${isEdit ? '수정' : '작성'}하였습니다.`
      });
      return navigate(`/community/qna/${questionId}`);
    },
    onError: () => {
      showToast({
        type: 'fail',
        message: `글 ${isEdit ? '수정' : '작성'}에 실패했습니다.`
      });
    }
  });

  return { answerMutate } as const;
};

export default useAnswerMutations;
